import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import PatientManulOverride from '../../common/patient_manual_override';
import { Box, Grid, IconButton } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
});

const TransactionSortObj = {
  firstname: { tableName: 'customers', sortColumn: 'first_name' },
  lastname: { tableName: 'customers', sortColumn: 'last_name' },
  patientNotes: { tableName: 'customers', sortColumn: 'notes' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  binid: { tableName: '', sortColumn: 'bin_id' },
  rxno: { tableName: 'prescription_detail', sortColumn: 'rx_no' },
  fillid: { tableName: 'prescription_detail', sortColumn: 'fillnumber' },
  prescriptionnumber: { tableName: 'prescription_detail', sortColumn: 'prescriptionnumber' },
  ndccode: { tableName: 'prescription_detail', sortColumn: 'ndc_code' },
  drugname: { tableName: 'prescription_detail', sortColumn: 'drug_name' },
  qty: { tableName: 'prescription_detail', sortColumn: 'qty' },
  price: { tableName: 'prescription_detail', sortColumn: 'price' },
  stockeddate: { tableName: '', sortColumn: 'stocked_date' },
  filldate: { tableName: '', sortColumn: 'fill_date' },
  stock_code: { tableName: '', sortColumn: 'stock_code' },
  pucode: { tableName: '', sortColumn: 'pucode' },
  deliverytype: { tableName: 'locationtype_master', sortColumn: 'name' },
  order_id: { tableName: 'prescription_detail', sortColumn: 'order_id' },
  prescription_txn_id: { tableName: 'prescription_detail', sortColumn: 'prescription_txn_id' },
  username: { tableName: 'users', sortColumn: 'name' },
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchObject: null,
  stockeddate: {
    fromdate: '',
    todate: '',
  },
  filldate: {
    fromdate: '',
    todate: '',
  },
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'stocked_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 25,
      boxvalues: [],
      accountValues: [],
      loader: false,
      selectedObject: null,
      isUserValidate: false,
      htmlBodyToPrint: '',
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      data: []
    };
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        this.setState({ accountValues: storelist, parent_account_id: storelist[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/CancelledItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['ID', 'Store', 'Box', 'BIN', 'Rx No', 'Fill ID', 'Patient Notes', 'Delivery Type', 'Prescription Number', 'Transaction ID', 'Order ID', 'Fill Date', 'Stock Date', 'StockCode', 'PickUpCode', 'FirstName', 'LastName', 'NDC Code', 'Drug Name', 'Qty', 'Amount Due', 'User']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.store,
                  i.box,
                  i.binid,
                  i.rxno,
                  i.fillid,
                  i.patientNotes,
                  i.deliverytype,
                  i.prescriptionnumber,
                  i.prescription_txn_id,
                  i.order_id,
                  i.filldate ? this.convertToTimeZone(i && i.filldate) : '',
                  i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : '',
                  i.stock_code,
                  i.pucode,
                  i.firstname,
                  i.lastname,
                  i.ndccode,
                  i.drugname.replaceAll(',', ' ').trim(),
                  i.qty,
                  i.price ? '$' + parseFloat(i.price).toFixed(2) : '$0.00',
                  i.username
                ]);
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "CancelledItemsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      })
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          this.setState({ boxvalues: boxlist });
          this.setState({ loader: false });
        });
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource(this.state.boxvalues, this.state.accountValues)
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.stockeddate.fromdate = '';
      TransactionFilterObj.stockeddate.todate = '';
      TransactionFilterObj.filldate.fromdate = '';
      TransactionFilterObj.filldate.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = (boxvalues, accountValues) => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set fromdate and todate for stocked date
        if (filterObject.stockeddate) {
          const dateValue = filterObject.stockeddate;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.stockeddate.fromdate = date1
              TransactionFilterObj.stockeddate.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.stockeddate.fromdate = date1
              TransactionFilterObj.stockeddate.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.stockeddate.fromdate = date
              TransactionFilterObj.stockeddate.todate = ''
            } else {
              TransactionFilterObj.stockeddate.todate = date
              TransactionFilterObj.stockeddate.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.stockeddate.todate = '';
          TransactionFilterObj.stockeddate.fromdate = ''
        }

        // to set fromdate and todate for fill date
        if (filterObject.filldate) {
          const dateValue = filterObject.filldate;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.filldate.fromdate = date1
              TransactionFilterObj.filldate.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.filldate.fromdate = date1
              TransactionFilterObj.filldate.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.filldate.fromdate = date
              TransactionFilterObj.filldate.todate = ''
            } else {
              TransactionFilterObj.filldate.todate = date
              TransactionFilterObj.filldate.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.filldate.todate = '';
          TransactionFilterObj.filldate.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        // const element = document.activeElement

        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

        // if (filterColumns.length > 0) { // if true means filter or cleared filters means api call
        if (isStoreNotSelected === true || isBoxNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0)
          self.setState({ data: [], isButtonDisabled: true })
        } else { // store or box is selected
          //     if (element && element.getAttribute("aria-label") === "BIN Filter Input") { // bypass validation for binid
          apiCall()
          //     } else {
          //       if (element && element.value && (element.value.length >= 3 || element.value === "on")) {
          //         // validation or selection of store & box or page change
          //         apiCall()
          //       } else {
          //         params.successCallback(self.state.data, self.state.data.length)
          //       }
          //     }
        }
        // } else { // for clear filter
        // apiCall()
        // }

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getCancelledlist', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  LinkValueRenderer = (params) => {
    return (
      <a
        href=''
        title='View Pick up by'
        style={{
          color: '#385cad',
          fontWeight: 500,
          textDecoration: 'none ',
          fontSize: '1rem',
        }}
        onClick={(event) =>
          this.handlePUcodeClick(event, params.data.pmid)
        }
      >
        {' '}
        {params.value}
      </a>
    )
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  handlePUcodeClick = (event, pmid) => {
    event.preventDefault();
    const selectedObject = this.state.data.find(x => x.pmid === pmid);
    this.setState({ detailDialogOpen: true, selectedObject: selectedObject, isUserValidate: false })
  }

  handlePUcodeClose = () => {
    this.setState({ detailDialogOpen: false, selectedObject: null, isUserValidate: false });
  }

  exportPDF = () => {
    try {
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'printDeliveryManifestCancelledItems', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(TransactionFilterObj)

      })
        .then((response) => {
          try {
            return response.text()
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ loader: false });
          var x = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,left=145,top=100');
          x.document.write(res);
          x.document.close();
          setTimeout(() => {
            x.print();
            x.close();
          }, 1300)
        })
        .catch((error) => {
          this.setState({ loader: false });
        })
    } catch (error) {
      this.setState({ loader: false });
    }
  }

  AmountValueRenderer = (params) => {
    return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
  }

  setHtmlForPrint = (data) => this.setState({ htmlBodyToPrint: data });

  render() {
    const { classes, t } = this.props;
    const { data, accountValues, boxvalues } = this.state;

    const columnDefs = [
      { field: "firstname", headerName: t("Report.Cancelled.FirstName"), },
      { field: "lastname", headerName: t("Report.Cancelled.LastName") },
      { field: "rxno", headerName: t("Report.Cancelled.RxHash") },
      { field: "prescriptionnumber", headerName: t("Report.Cancelled.PrescriptionNumber") },
      { field: "drugname", headerName: t("Report.Cancelled.DrugName") },
      { field: "stock_code", headerName: t("Report.Cancelled.StockCode") },
      { field: "pucode", headerName: t("Report.Cancelled.PUCode"), cellRenderer: this.LinkValueRenderer },
      {
        field: "store", headerName: t("Report.Cancelled.Store"), filter: true,
        filterParams: {
          values: accountValues.map(account => {
            return account.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        field: "box", headerName: t("Report.Cancelled.Location"), filter: true,
        filterParams: {
          values: boxvalues.map(box => {
            return box.name
          })
        },
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      { field: "deliverytype", headerName: t("Report.Cancelled.DeliverType") },
      { field: "binid", headerName: t("Report.Cancelled.BIN") },
      { field: "fillid", headerName: t("Report.Cancelled.FillID") },
      { field: "order_id", headerName: t("Report.Cancelled.OrderID") },
      { field: "prescription_txn_id", headerName: t("Report.Cancelled.TransactionID") },
      { field: "ndccode", headerName: t("Report.Cancelled.NDCCode") },
      { field: "qty", headerName: t("Report.Cancelled.Qty"), filter: false },
      { field: "price", headerName: t("Report.Cancelled.AmountDue"), filter: false, cellRenderer: this.AmountValueRenderer },
      {
        field: "stockeddate", headerName: t("Report.Cancelled.StockDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Cancelled.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Cancelled.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      {
        field: "filldate", headerName: t("Report.Cancelled.FillDate"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Cancelled.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Cancelled.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      },
      { field: "patientNotes", headerName: t("Report.Cancelled.PatientNotes"), filter: false },
      { field: "username", headerName: t("Report.Cancelled.User") },
    ];

    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div>
          {
            this.state.detailDialogOpen ?
              <PatientManulOverride
                detailDialogOpen={this.state.detailDialogOpen}
                selectedObject={this.state.selectedObject}
                isUserValidate={this.state.isUserValidate}
                onPopupClose={this.handlePUcodeClose}
                setHtmlForPrint={this.setHtmlForPrint}
                isPatientDetailsVisible={true}
                isBoxDetailsVisible={true}
                isManualOverrideVisible={true}
                isManualConsultVisible={true}
              /> : null
          }
          <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
              <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                <Tooltip key="clear-filters" title={t("Report.Cancelled.ClearFiltersTooltip")}>
                  <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                    <CloseIcon style={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip key="export-csv" title="ExportCSV">
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label={t("Report.Cancelled.ExportCSVTooltip")}
                    onClick={() => { this.exportCSV() }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip key="export-pdf" title={t("Report.Cancelled.ExportPDFTooltip")}>
                  <IconButton
                    aria-label="ExportPDF"
                    onClick={() => { this.exportPDF() }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
          {this.state.accountValues.length && this.state.boxvalues.length ?
            <ReportsAGGrid
              columnDefs={columnDefs}
              sideBar={false}
              suppressMenuHide={true}
              rowData={data}
              defaultColDef={{
                flex: 1,
                minWidth: 150,
                floatingFilter: true,
                filter: 'agTextColumnFilter',
                filterParams: {
                  filterOptions: [{
                    displayKey: 'searchtext',
                    displayName: 'Search Text',
                    predicate: (cellValue) => cellValue
                  }],
                  maxNumConditions: 1,
                },
                resizable: true,
                sortable: true,
                menuTabs: ['generalMenuTab', 'columnsMenuTab'],
              }}
              onGridReady={this.onGridReady}
            />
            : null
          }
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/cancelled-list/index.js